import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const registerByWechatMiniProgram = (params, urlParams) => {
  return axios.request({
    url: '/wxmp/wechatminiprogramaccount/registerbywechatminiprogram' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const loginByWechatMiniProgram = (params, urlParams) => {
  return axios.request({
    url: '/wxmp/wechatminiprogramaccount/loginbywechatminiprogram' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getPhoneNumber = (params, urlParams) => {
  return axios.request({
    url: '/wxmp/wechatminiprogramaccount/getphonenumber' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const testTrans = (params, urlParams) => {
  return axios.request({
    url: '/wxmp/wechatminiprogramaccount/testtrans' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

